import { t } from "@lingui/macro";
import { Tier } from "../models/local/Tiers";

export function GetTiers(): Tier[] {
  return [
    new Tier('FREE', t`Free`, 0, [
      t`10 GB storage`,
      t`Unlimited users`,
      t`Unlimited workspaces`,
      t`Unlimited rooms`,
      t`Unlimited messages`,
    ]),
    new Tier('BASIC', t`Basic`, 30000, [
      t`All Free features, plus:`,
      t`100 GB storage`,
      t`Group calls via Twilio`,
      t`Unlimited message search`,
    ]),
    new Tier('STANDARD', t`Standard`, 100000, [
      t`All Basic features, plus:`,
      t`500 GB storage`,
      t`Dall-E bot`,
      t`Search bot`,
    ]),
    new Tier('PREMIUM', t`Premium`, 300000, [
      t`All Standard features, plus:`,
      t`2000 GB storage`,
      t`Create Soribots`,
    ]),
  ];
}